/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as SelectTenantRouteImport } from './routes/select-tenant'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAiChatRouteImport } from './routes/_app/ai-chat'
import { Route as AppApprovalsRouteImport } from './routes/_app/approvals'
import { Route as AppBillingRouteImport } from './routes/_app/billing'
import { Route as AppBillsRouteImport } from './routes/_app/bills'
import { Route as AppBranchCompareRouteImport } from './routes/_app/branch-compare'
import { Route as AppCalendarRouteImport } from './routes/_app/calendar'
import { Route as AppCashRouteImport } from './routes/_app/cash'
import { Route as AppCloseDayRouteImport } from './routes/_app/close-day'
import { Route as AppComplaintsRouteImport } from './routes/_app/complaints'
import { Route as AppFinanceRouteImport } from './routes/_app/finance'
import { Route as AppFollowupsRouteImport } from './routes/_app/followups'
import { Route as AppGoalsRouteImport } from './routes/_app/goals'
import { Route as AppHealthRouteImport } from './routes/_app/health'
import { Route as AppInboxRouteImport } from './routes/_app/inbox'
import { Route as AppKpiRouteImport } from './routes/_app/kpi'
import { Route as AppLeaveRequestsRouteImport } from './routes/_app/leave-requests'
import { Route as AppLoyaltyRouteImport } from './routes/_app/loyalty'
import { Route as AppManualRouteImport } from './routes/_app/manual'
import { Route as AppMessagesRouteImport } from './routes/_app/messages'
import { Route as AppOnlineBookingRouteImport } from './routes/_app/online-booking'
import { Route as AppOrdersRouteImport } from './routes/_app/orders'
import { Route as AppPayMethodRouteImport } from './routes/_app/pay-method'
import { Route as AppPayoutsRouteImport } from './routes/_app/payouts'
import { Route as AppPrivacyRouteImport } from './routes/_app/privacy'
import { Route as AppRatingsRouteImport } from './routes/_app/ratings'
import { Route as AppReceivingAccountsRouteImport } from './routes/_app/receiving-accounts'
import { Route as AppRentalReportRouteImport } from './routes/_app/rental-report'
import { Route as AppRentalsRouteImport } from './routes/_app/rentals'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppReportsInboxRouteImport } from './routes/_app/reports-inbox'
import { Route as AppRulesRouteImport } from './routes/_app/rules'
import { Route as AppSalesReportRouteImport } from './routes/_app/sales-report'
import { Route as AppSalesSummaryRouteImport } from './routes/_app/sales-summary'
import { Route as AppServiceRecordsRouteImport } from './routes/_app/service-records'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppSetupRouteImport } from './routes/_app/setup'
import { Route as AppStaffRouteImport } from './routes/_app/staff'
import { Route as AppTablesRouteImport } from './routes/_app/tables'
import { Route as AppTodayRouteImport } from './routes/_app/today'
import { Route as AppVacationTestRouteImport } from './routes/_app/vacation-test'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as ApproveTokenRouteImport } from './routes/approve.$token'
import { Route as AppAccountSecurityRouteImport } from './routes/_app/account.security'
import { Route as AppChecklistsIndexRouteImport } from './routes/_app/checklists.index'
import { Route as AppChecklistsNewRouteImport } from './routes/_app/checklists.new'
import { Route as AppCheckoutIndexRouteImport } from './routes/_app/checkout.index'
import { Route as AppClinicalIndexRouteImport } from './routes/_app/clinical.index'
import { Route as AppCustomersIndexRouteImport } from './routes/_app/customers/index'
import { Route as AppCustomersCustomerIdRouteImport } from './routes/_app/customers/$customerId'
import { Route as AppCustomersImportRouteImport } from './routes/_app/customers/import'
import { Route as AppHelpIndexRouteImport } from './routes/_app/help.index'
import { Route as AppHelpTopicRouteImport } from './routes/_app/help.$topic'
import { Route as AppImportsPosRouteImport } from './routes/_app/imports.pos'
import { Route as AppInventoryImportRouteImport } from './routes/_app/inventory.import'
import { Route as AppInventoryIngredientsRouteImport } from './routes/_app/inventory.ingredients'
import { Route as AppInventoryProductsRouteImport } from './routes/_app/inventory.products'
import { Route as AppInventoryReportsRouteImport } from './routes/_app/inventory.reports'
import { Route as AppInventorySellRouteImport } from './routes/_app/inventory.sell'
import { Route as AppInventoryStockRouteImport } from './routes/_app/inventory.stock'
import { Route as AppMeApprovalRouteImport } from './routes/_app/me/approval'
import { Route as AppMeChecklistsRouteImport } from './routes/_app/me/checklists'
import { Route as AppMeEarningsRouteImport } from './routes/_app/me/earnings'
import { Route as AppMeLeaveRouteImport } from './routes/_app/me/leave'
import { Route as AppMeNotificationsRouteImport } from './routes/_app/me/notifications'
import { Route as AppMeScheduleRouteImport } from './routes/_app/me/schedule'
import { Route as AppMeSopsRouteImport } from './routes/_app/me/sops'
import { Route as AppMeTodayRouteImport } from './routes/_app/me/today'
import { Route as AppMessagesIndexRouteImport } from './routes/_app/messages.index'
import { Route as AppMessagesJobsRouteImport } from './routes/_app/messages.jobs'
import { Route as AppMessagesPlansRouteImport } from './routes/_app/messages.plans'
import { Route as AppMessagesTemplatesRouteImport } from './routes/_app/messages.templates'
import { Route as AppRentalsImportRouteImport } from './routes/_app/rentals_.import'
import { Route as AppRentalsImportBookingsRouteImport } from './routes/_app/rentals_.import-bookings'
import { Route as AppRentalsPhotosRouteImport } from './routes/_app/rentals_.photos'
import { Route as AppRulesIndexRouteImport } from './routes/_app/rules.index'
import { Route as AppRulesBookingRouteImport } from './routes/_app/rules.booking'
import { Route as AppRulesCompensationRouteImport } from './routes/_app/rules.compensation'
import { Route as AppRulesDiscountRouteImport } from './routes/_app/rules.discount'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsAiChatRouteImport } from './routes/_app/settings/ai-chat'
import { Route as AppSettingsApprovalsRouteImport } from './routes/_app/settings/approvals'
import { Route as AppSettingsBranchesRouteImport } from './routes/_app/settings/branches'
import { Route as AppSettingsClinicalRouteImport } from './routes/_app/settings/clinical'
import { Route as AppSettingsCustomersRouteImport } from './routes/_app/settings/customers'
import { Route as AppSettingsInventoryRouteImport } from './routes/_app/settings/inventory'
import { Route as AppSettingsLineRouteImport } from './routes/_app/settings/line'
import { Route as AppSettingsMembersRouteImport } from './routes/_app/settings/members'
import { Route as AppSettingsMetaChannelsRouteImport } from './routes/_app/settings/meta-channels'
import { Route as AppSettingsOnlineBookingRouteImport } from './routes/_app/settings/online-booking'
import { Route as AppSettingsOnlineOrderingRouteImport } from './routes/_app/settings/online-ordering'
import { Route as AppSettingsPaymentsRouteImport } from './routes/_app/settings/payments'
import { Route as AppSettingsPositionsRouteImport } from './routes/_app/settings/positions'
import { Route as AppSettingsRemindersRouteImport } from './routes/_app/settings/reminders'
import { Route as AppSettingsRentalRouteImport } from './routes/_app/settings/rental'
import { Route as AppSettingsResourcesRouteImport } from './routes/_app/settings/resources'
import { Route as AppSettingsRolesRouteImport } from './routes/_app/settings/roles'
import { Route as AppSettingsSkillsRouteImport } from './routes/_app/settings/skills'
import { Route as AppSettingsTenantRouteImport } from './routes/_app/settings/tenant'
import { Route as AppShiftsIndexRouteImport } from './routes/_app/shifts.index'
import { Route as AppShiftsTemplatesRouteImport } from './routes/_app/shifts.templates'
import { Route as AppSopsIndexRouteImport } from './routes/_app/sops.index'
import { Route as AppSopsNewRouteImport } from './routes/_app/sops.new'
import { Route as AppSurveysIndexRouteImport } from './routes/_app/surveys/index'
import { Route as AppSurveysIdRouteImport } from './routes/_app/surveys/$id'
import { Route as AppTeamRiskRouteImport } from './routes/_app/team/risk'
import { Route as AuthInviteTokenRouteImport } from './routes/_auth/invite.$token'
import { Route as PublicPayTokenRouteImport } from './routes/_public/pay.$token'
import { Route as PublicRIndexRouteImport } from './routes/_public/r.index'
import { Route as PublicRCodeRouteImport } from './routes/_public/r.$code'
import { Route as PublicSTokenRouteImport } from './routes/_public/s.$token'
import { Route as AppChecklistsIdEditRouteImport } from './routes/_app/checklists.$id.edit'
import { Route as AppChecklistsRunsRunIdRouteImport } from './routes/_app/checklists.runs.$runId'
import { Route as AppCheckoutBillIdIndexRouteImport } from './routes/_app/checkout.$billId.index'
import { Route as AppCheckoutBillIdReceiptRouteImport } from './routes/_app/checkout.$billId.receipt'
import { Route as AppClinicalPatientsCustomerIdRouteImport } from './routes/_app/clinical.patients.$customerId'
import { Route as AppInventoryCountIndexRouteImport } from './routes/_app/inventory.count.index'
import { Route as AppInventoryCountIdRouteImport } from './routes/_app/inventory.count.$id'
import { Route as AppSettingsLineGuideRouteImport } from './routes/_app/settings/line_.guide'
import { Route as AppSettingsServicesIndexRouteImport } from './routes/_app/settings/services/index'
import { Route as AppSettingsServicesImportRouteImport } from './routes/_app/settings/services/import'
import { Route as AppSopsIdEditRouteImport } from './routes/_app/sops.$id.edit'
import { Route as AppTeamIdOffboardingRouteImport } from './routes/_app/team/$id/offboarding'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpersonateRoute = ImpersonateRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const SelectTenantRoute = SelectTenantRouteImport.update({
  id: '/select-tenant',
  path: '/select-tenant',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAiChatRoute = AppAiChatRouteImport.update({
  id: '/ai-chat',
  path: '/ai-chat',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsRoute = AppApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppRoute,
} as any)
const AppBillsRoute = AppBillsRouteImport.update({
  id: '/bills',
  path: '/bills',
  getParentRoute: () => AppRoute,
} as any)
const AppBranchCompareRoute = AppBranchCompareRouteImport.update({
  id: '/branch-compare',
  path: '/branch-compare',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppCashRoute = AppCashRouteImport.update({
  id: '/cash',
  path: '/cash',
  getParentRoute: () => AppRoute,
} as any)
const AppCloseDayRoute = AppCloseDayRouteImport.update({
  id: '/close-day',
  path: '/close-day',
  getParentRoute: () => AppRoute,
} as any)
const AppComplaintsRoute = AppComplaintsRouteImport.update({
  id: '/complaints',
  path: '/complaints',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceRoute = AppFinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => AppRoute,
} as any)
const AppFollowupsRoute = AppFollowupsRouteImport.update({
  id: '/followups',
  path: '/followups',
  getParentRoute: () => AppRoute,
} as any)
const AppGoalsRoute = AppGoalsRouteImport.update({
  id: '/goals',
  path: '/goals',
  getParentRoute: () => AppRoute,
} as any)
const AppHealthRoute = AppHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppKpiRoute = AppKpiRouteImport.update({
  id: '/kpi',
  path: '/kpi',
  getParentRoute: () => AppRoute,
} as any)
const AppLeaveRequestsRoute = AppLeaveRequestsRouteImport.update({
  id: '/leave-requests',
  path: '/leave-requests',
  getParentRoute: () => AppRoute,
} as any)
const AppLoyaltyRoute = AppLoyaltyRouteImport.update({
  id: '/loyalty',
  path: '/loyalty',
  getParentRoute: () => AppRoute,
} as any)
const AppManualRoute = AppManualRouteImport.update({
  id: '/manual',
  path: '/manual',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesRoute = AppMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AppRoute,
} as any)
const AppOnlineBookingRoute = AppOnlineBookingRouteImport.update({
  id: '/online-booking',
  path: '/online-booking',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersRoute = AppOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppPayMethodRoute = AppPayMethodRouteImport.update({
  id: '/pay-method',
  path: '/pay-method',
  getParentRoute: () => AppRoute,
} as any)
const AppPayoutsRoute = AppPayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => AppRoute,
} as any)
const AppPrivacyRoute = AppPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => AppRoute,
} as any)
const AppRatingsRoute = AppRatingsRouteImport.update({
  id: '/ratings',
  path: '/ratings',
  getParentRoute: () => AppRoute,
} as any)
const AppReceivingAccountsRoute = AppReceivingAccountsRouteImport.update({
  id: '/receiving-accounts',
  path: '/receiving-accounts',
  getParentRoute: () => AppRoute,
} as any)
const AppRentalReportRoute = AppRentalReportRouteImport.update({
  id: '/rental-report',
  path: '/rental-report',
  getParentRoute: () => AppRoute,
} as any)
const AppRentalsRoute = AppRentalsRouteImport.update({
  id: '/rentals',
  path: '/rentals',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsInboxRoute = AppReportsInboxRouteImport.update({
  id: '/reports-inbox',
  path: '/reports-inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppRulesRoute = AppRulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesReportRoute = AppSalesReportRouteImport.update({
  id: '/sales-report',
  path: '/sales-report',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesSummaryRoute = AppSalesSummaryRouteImport.update({
  id: '/sales-summary',
  path: '/sales-summary',
  getParentRoute: () => AppRoute,
} as any)
const AppServiceRecordsRoute = AppServiceRecordsRouteImport.update({
  id: '/service-records',
  path: '/service-records',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSetupRoute = AppSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AppRoute,
} as any)
const AppStaffRoute = AppStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AppRoute,
} as any)
const AppTablesRoute = AppTablesRouteImport.update({
  id: '/tables',
  path: '/tables',
  getParentRoute: () => AppRoute,
} as any)
const AppTodayRoute = AppTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AppRoute,
} as any)
const AppVacationTestRoute = AppVacationTestRouteImport.update({
  id: '/vacation-test',
  path: '/vacation-test',
  getParentRoute: () => AppRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const ApproveTokenRoute = ApproveTokenRouteImport.update({
  id: '/approve/$token',
  path: '/approve/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountSecurityRoute = AppAccountSecurityRouteImport.update({
  id: '/account/security',
  path: '/account/security',
  getParentRoute: () => AppRoute,
} as any)
const AppChecklistsIndexRoute = AppChecklistsIndexRouteImport.update({
  id: '/checklists/',
  path: '/checklists/',
  getParentRoute: () => AppRoute,
} as any)
const AppChecklistsNewRoute = AppChecklistsNewRouteImport.update({
  id: '/checklists/new',
  path: '/checklists/new',
  getParentRoute: () => AppRoute,
} as any)
const AppCheckoutIndexRoute = AppCheckoutIndexRouteImport.update({
  id: '/checkout/',
  path: '/checkout/',
  getParentRoute: () => AppRoute,
} as any)
const AppClinicalIndexRoute = AppClinicalIndexRouteImport.update({
  id: '/clinical/',
  path: '/clinical/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersCustomerIdRoute = AppCustomersCustomerIdRouteImport.update({
  id: '/customers/$customerId',
  path: '/customers/$customerId',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersImportRoute = AppCustomersImportRouteImport.update({
  id: '/customers/import',
  path: '/customers/import',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpIndexRoute = AppHelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpTopicRoute = AppHelpTopicRouteImport.update({
  id: '/help/$topic',
  path: '/help/$topic',
  getParentRoute: () => AppRoute,
} as any)
const AppImportsPosRoute = AppImportsPosRouteImport.update({
  id: '/imports/pos',
  path: '/imports/pos',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryImportRoute = AppInventoryImportRouteImport.update({
  id: '/inventory/import',
  path: '/inventory/import',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryIngredientsRoute = AppInventoryIngredientsRouteImport.update({
  id: '/inventory/ingredients',
  path: '/inventory/ingredients',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryProductsRoute = AppInventoryProductsRouteImport.update({
  id: '/inventory/products',
  path: '/inventory/products',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryReportsRoute = AppInventoryReportsRouteImport.update({
  id: '/inventory/reports',
  path: '/inventory/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppInventorySellRoute = AppInventorySellRouteImport.update({
  id: '/inventory/sell',
  path: '/inventory/sell',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryStockRoute = AppInventoryStockRouteImport.update({
  id: '/inventory/stock',
  path: '/inventory/stock',
  getParentRoute: () => AppRoute,
} as any)
const AppMeApprovalRoute = AppMeApprovalRouteImport.update({
  id: '/me/approval',
  path: '/me/approval',
  getParentRoute: () => AppRoute,
} as any)
const AppMeChecklistsRoute = AppMeChecklistsRouteImport.update({
  id: '/me/checklists',
  path: '/me/checklists',
  getParentRoute: () => AppRoute,
} as any)
const AppMeEarningsRoute = AppMeEarningsRouteImport.update({
  id: '/me/earnings',
  path: '/me/earnings',
  getParentRoute: () => AppRoute,
} as any)
const AppMeLeaveRoute = AppMeLeaveRouteImport.update({
  id: '/me/leave',
  path: '/me/leave',
  getParentRoute: () => AppRoute,
} as any)
const AppMeNotificationsRoute = AppMeNotificationsRouteImport.update({
  id: '/me/notifications',
  path: '/me/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppMeScheduleRoute = AppMeScheduleRouteImport.update({
  id: '/me/schedule',
  path: '/me/schedule',
  getParentRoute: () => AppRoute,
} as any)
const AppMeSopsRoute = AppMeSopsRouteImport.update({
  id: '/me/sops',
  path: '/me/sops',
  getParentRoute: () => AppRoute,
} as any)
const AppMeTodayRoute = AppMeTodayRouteImport.update({
  id: '/me/today',
  path: '/me/today',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesIndexRoute = AppMessagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMessagesRoute,
} as any)
const AppMessagesJobsRoute = AppMessagesJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AppMessagesRoute,
} as any)
const AppMessagesPlansRoute = AppMessagesPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AppMessagesRoute,
} as any)
const AppMessagesTemplatesRoute = AppMessagesTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppMessagesRoute,
} as any)
const AppRentalsImportRoute = AppRentalsImportRouteImport.update({
  id: '/rentals_/import',
  path: '/rentals/import',
  getParentRoute: () => AppRoute,
} as any)
const AppRentalsImportBookingsRoute =
  AppRentalsImportBookingsRouteImport.update({
    id: '/rentals_/import-bookings',
    path: '/rentals/import-bookings',
    getParentRoute: () => AppRoute,
  } as any)
const AppRentalsPhotosRoute = AppRentalsPhotosRouteImport.update({
  id: '/rentals_/photos',
  path: '/rentals/photos',
  getParentRoute: () => AppRoute,
} as any)
const AppRulesIndexRoute = AppRulesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRulesRoute,
} as any)
const AppRulesBookingRoute = AppRulesBookingRouteImport.update({
  id: '/booking',
  path: '/booking',
  getParentRoute: () => AppRulesRoute,
} as any)
const AppRulesCompensationRoute = AppRulesCompensationRouteImport.update({
  id: '/compensation',
  path: '/compensation',
  getParentRoute: () => AppRulesRoute,
} as any)
const AppRulesDiscountRoute = AppRulesDiscountRouteImport.update({
  id: '/discount',
  path: '/discount',
  getParentRoute: () => AppRulesRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAiChatRoute = AppSettingsAiChatRouteImport.update({
  id: '/ai-chat',
  path: '/ai-chat',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsApprovalsRoute = AppSettingsApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsBranchesRoute = AppSettingsBranchesRouteImport.update({
  id: '/branches',
  path: '/branches',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsClinicalRoute = AppSettingsClinicalRouteImport.update({
  id: '/clinical',
  path: '/clinical',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsCustomersRoute = AppSettingsCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsInventoryRoute = AppSettingsInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsLineRoute = AppSettingsLineRouteImport.update({
  id: '/line',
  path: '/line',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsMembersRoute = AppSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsMetaChannelsRoute = AppSettingsMetaChannelsRouteImport.update({
  id: '/meta-channels',
  path: '/meta-channels',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsOnlineBookingRoute =
  AppSettingsOnlineBookingRouteImport.update({
    id: '/online-booking',
    path: '/online-booking',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsOnlineOrderingRoute =
  AppSettingsOnlineOrderingRouteImport.update({
    id: '/online-ordering',
    path: '/online-ordering',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsPaymentsRoute = AppSettingsPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsPositionsRoute = AppSettingsPositionsRouteImport.update({
  id: '/positions',
  path: '/positions',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsRemindersRoute = AppSettingsRemindersRouteImport.update({
  id: '/reminders',
  path: '/reminders',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsRentalRoute = AppSettingsRentalRouteImport.update({
  id: '/rental',
  path: '/rental',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsResourcesRoute = AppSettingsResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsRolesRoute = AppSettingsRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSkillsRoute = AppSettingsSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTenantRoute = AppSettingsTenantRouteImport.update({
  id: '/tenant',
  path: '/tenant',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppShiftsIndexRoute = AppShiftsIndexRouteImport.update({
  id: '/shifts/',
  path: '/shifts/',
  getParentRoute: () => AppRoute,
} as any)
const AppShiftsTemplatesRoute = AppShiftsTemplatesRouteImport.update({
  id: '/shifts/templates',
  path: '/shifts/templates',
  getParentRoute: () => AppRoute,
} as any)
const AppSopsIndexRoute = AppSopsIndexRouteImport.update({
  id: '/sops/',
  path: '/sops/',
  getParentRoute: () => AppRoute,
} as any)
const AppSopsNewRoute = AppSopsNewRouteImport.update({
  id: '/sops/new',
  path: '/sops/new',
  getParentRoute: () => AppRoute,
} as any)
const AppSurveysIndexRoute = AppSurveysIndexRouteImport.update({
  id: '/surveys/',
  path: '/surveys/',
  getParentRoute: () => AppRoute,
} as any)
const AppSurveysIdRoute = AppSurveysIdRouteImport.update({
  id: '/surveys/$id',
  path: '/surveys/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamRiskRoute = AppTeamRiskRouteImport.update({
  id: '/team/risk',
  path: '/team/risk',
  getParentRoute: () => AppRoute,
} as any)
const AuthInviteTokenRoute = AuthInviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => AuthRoute,
} as any)
const PublicPayTokenRoute = PublicPayTokenRouteImport.update({
  id: '/pay/$token',
  path: '/pay/$token',
  getParentRoute: () => PublicRoute,
} as any)
const PublicRIndexRoute = PublicRIndexRouteImport.update({
  id: '/r/',
  path: '/r/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicRCodeRoute = PublicRCodeRouteImport.update({
  id: '/r/$code',
  path: '/r/$code',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSTokenRoute = PublicSTokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => PublicRoute,
} as any)
const AppChecklistsIdEditRoute = AppChecklistsIdEditRouteImport.update({
  id: '/checklists/$id/edit',
  path: '/checklists/$id/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppChecklistsRunsRunIdRoute = AppChecklistsRunsRunIdRouteImport.update({
  id: '/checklists/runs/$runId',
  path: '/checklists/runs/$runId',
  getParentRoute: () => AppRoute,
} as any)
const AppCheckoutBillIdIndexRoute = AppCheckoutBillIdIndexRouteImport.update({
  id: '/checkout/$billId/',
  path: '/checkout/$billId/',
  getParentRoute: () => AppRoute,
} as any)
const AppCheckoutBillIdReceiptRoute =
  AppCheckoutBillIdReceiptRouteImport.update({
    id: '/checkout/$billId/receipt',
    path: '/checkout/$billId/receipt',
    getParentRoute: () => AppRoute,
  } as any)
const AppClinicalPatientsCustomerIdRoute =
  AppClinicalPatientsCustomerIdRouteImport.update({
    id: '/clinical/patients/$customerId',
    path: '/clinical/patients/$customerId',
    getParentRoute: () => AppRoute,
  } as any)
const AppInventoryCountIndexRoute = AppInventoryCountIndexRouteImport.update({
  id: '/inventory/count/',
  path: '/inventory/count/',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryCountIdRoute = AppInventoryCountIdRouteImport.update({
  id: '/inventory/count/$id',
  path: '/inventory/count/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsLineGuideRoute = AppSettingsLineGuideRouteImport.update({
  id: '/line_/guide',
  path: '/line/guide',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsServicesIndexRoute =
  AppSettingsServicesIndexRouteImport.update({
    id: '/services/',
    path: '/services/',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsServicesImportRoute =
  AppSettingsServicesImportRouteImport.update({
    id: '/services/import',
    path: '/services/import',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSopsIdEditRoute = AppSopsIdEditRouteImport.update({
  id: '/sops/$id/edit',
  path: '/sops/$id/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamIdOffboardingRoute = AppTeamIdOffboardingRouteImport.update({
  id: '/team/$id/offboarding',
  path: '/team/$id/offboarding',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/impersonate': typeof ImpersonateRoute
  '/onboarding': typeof OnboardingRoute
  '/select-tenant': typeof SelectTenantRoute
  '/verify-email': typeof VerifyEmailRoute
  '/ai-chat': typeof AppAiChatRoute
  '/approvals': typeof AppApprovalsRoute
  '/billing': typeof AppBillingRoute
  '/bills': typeof AppBillsRoute
  '/branch-compare': typeof AppBranchCompareRoute
  '/calendar': typeof AppCalendarRoute
  '/cash': typeof AppCashRoute
  '/close-day': typeof AppCloseDayRoute
  '/complaints': typeof AppComplaintsRoute
  '/finance': typeof AppFinanceRoute
  '/followups': typeof AppFollowupsRoute
  '/goals': typeof AppGoalsRoute
  '/health': typeof AppHealthRoute
  '/inbox': typeof AppInboxRoute
  '/kpi': typeof AppKpiRoute
  '/leave-requests': typeof AppLeaveRequestsRoute
  '/loyalty': typeof AppLoyaltyRoute
  '/manual': typeof AppManualRoute
  '/messages': typeof AppMessagesRouteWithChildren
  '/online-booking': typeof AppOnlineBookingRoute
  '/orders': typeof AppOrdersRoute
  '/pay-method': typeof AppPayMethodRoute
  '/payouts': typeof AppPayoutsRoute
  '/privacy': typeof AppPrivacyRoute
  '/ratings': typeof AppRatingsRoute
  '/receiving-accounts': typeof AppReceivingAccountsRoute
  '/rental-report': typeof AppRentalReportRoute
  '/rentals': typeof AppRentalsRoute
  '/reports': typeof AppReportsRoute
  '/reports-inbox': typeof AppReportsInboxRoute
  '/rules': typeof AppRulesRouteWithChildren
  '/sales-report': typeof AppSalesReportRoute
  '/sales-summary': typeof AppSalesSummaryRoute
  '/service-records': typeof AppServiceRecordsRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/setup': typeof AppSetupRoute
  '/staff': typeof AppStaffRoute
  '/tables': typeof AppTablesRoute
  '/today': typeof AppTodayRoute
  '/vacation-test': typeof AppVacationTestRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/approve/$token': typeof ApproveTokenRoute
  '/account/security': typeof AppAccountSecurityRoute
  '/checklists/new': typeof AppChecklistsNewRoute
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/customers/import': typeof AppCustomersImportRoute
  '/help/$topic': typeof AppHelpTopicRoute
  '/imports/pos': typeof AppImportsPosRoute
  '/inventory/import': typeof AppInventoryImportRoute
  '/inventory/ingredients': typeof AppInventoryIngredientsRoute
  '/inventory/products': typeof AppInventoryProductsRoute
  '/inventory/reports': typeof AppInventoryReportsRoute
  '/inventory/sell': typeof AppInventorySellRoute
  '/inventory/stock': typeof AppInventoryStockRoute
  '/me/approval': typeof AppMeApprovalRoute
  '/me/checklists': typeof AppMeChecklistsRoute
  '/me/earnings': typeof AppMeEarningsRoute
  '/me/leave': typeof AppMeLeaveRoute
  '/me/notifications': typeof AppMeNotificationsRoute
  '/me/schedule': typeof AppMeScheduleRoute
  '/me/sops': typeof AppMeSopsRoute
  '/me/today': typeof AppMeTodayRoute
  '/messages/jobs': typeof AppMessagesJobsRoute
  '/messages/plans': typeof AppMessagesPlansRoute
  '/messages/templates': typeof AppMessagesTemplatesRoute
  '/rentals/import': typeof AppRentalsImportRoute
  '/rentals/import-bookings': typeof AppRentalsImportBookingsRoute
  '/rentals/photos': typeof AppRentalsPhotosRoute
  '/rules/booking': typeof AppRulesBookingRoute
  '/rules/compensation': typeof AppRulesCompensationRoute
  '/rules/discount': typeof AppRulesDiscountRoute
  '/settings/ai-chat': typeof AppSettingsAiChatRoute
  '/settings/approvals': typeof AppSettingsApprovalsRoute
  '/settings/branches': typeof AppSettingsBranchesRoute
  '/settings/clinical': typeof AppSettingsClinicalRoute
  '/settings/customers': typeof AppSettingsCustomersRoute
  '/settings/inventory': typeof AppSettingsInventoryRoute
  '/settings/line': typeof AppSettingsLineRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/settings/meta-channels': typeof AppSettingsMetaChannelsRoute
  '/settings/online-booking': typeof AppSettingsOnlineBookingRoute
  '/settings/online-ordering': typeof AppSettingsOnlineOrderingRoute
  '/settings/payments': typeof AppSettingsPaymentsRoute
  '/settings/positions': typeof AppSettingsPositionsRoute
  '/settings/reminders': typeof AppSettingsRemindersRoute
  '/settings/rental': typeof AppSettingsRentalRoute
  '/settings/resources': typeof AppSettingsResourcesRoute
  '/settings/roles': typeof AppSettingsRolesRoute
  '/settings/skills': typeof AppSettingsSkillsRoute
  '/settings/tenant': typeof AppSettingsTenantRoute
  '/shifts/templates': typeof AppShiftsTemplatesRoute
  '/sops/new': typeof AppSopsNewRoute
  '/surveys/$id': typeof AppSurveysIdRoute
  '/team/risk': typeof AppTeamRiskRoute
  '/invite/$token': typeof AuthInviteTokenRoute
  '/pay/$token': typeof PublicPayTokenRoute
  '/r/$code': typeof PublicRCodeRoute
  '/s/$token': typeof PublicSTokenRoute
  '/checklists/': typeof AppChecklistsIndexRoute
  '/checkout/': typeof AppCheckoutIndexRoute
  '/clinical/': typeof AppClinicalIndexRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/help/': typeof AppHelpIndexRoute
  '/messages/': typeof AppMessagesIndexRoute
  '/rules/': typeof AppRulesIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/shifts/': typeof AppShiftsIndexRoute
  '/sops/': typeof AppSopsIndexRoute
  '/surveys/': typeof AppSurveysIndexRoute
  '/r/': typeof PublicRIndexRoute
  '/checklists/$id/edit': typeof AppChecklistsIdEditRoute
  '/checklists/runs/$runId': typeof AppChecklistsRunsRunIdRoute
  '/checkout/$billId/receipt': typeof AppCheckoutBillIdReceiptRoute
  '/clinical/patients/$customerId': typeof AppClinicalPatientsCustomerIdRoute
  '/inventory/count/$id': typeof AppInventoryCountIdRoute
  '/settings/line/guide': typeof AppSettingsLineGuideRoute
  '/settings/services/import': typeof AppSettingsServicesImportRoute
  '/sops/$id/edit': typeof AppSopsIdEditRoute
  '/team/$id/offboarding': typeof AppTeamIdOffboardingRoute
  '/checkout/$billId/': typeof AppCheckoutBillIdIndexRoute
  '/inventory/count/': typeof AppInventoryCountIndexRoute
  '/settings/services/': typeof AppSettingsServicesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/impersonate': typeof ImpersonateRoute
  '/onboarding': typeof OnboardingRoute
  '/select-tenant': typeof SelectTenantRoute
  '/verify-email': typeof VerifyEmailRoute
  '/ai-chat': typeof AppAiChatRoute
  '/approvals': typeof AppApprovalsRoute
  '/billing': typeof AppBillingRoute
  '/bills': typeof AppBillsRoute
  '/branch-compare': typeof AppBranchCompareRoute
  '/calendar': typeof AppCalendarRoute
  '/cash': typeof AppCashRoute
  '/close-day': typeof AppCloseDayRoute
  '/complaints': typeof AppComplaintsRoute
  '/finance': typeof AppFinanceRoute
  '/followups': typeof AppFollowupsRoute
  '/goals': typeof AppGoalsRoute
  '/health': typeof AppHealthRoute
  '/inbox': typeof AppInboxRoute
  '/kpi': typeof AppKpiRoute
  '/leave-requests': typeof AppLeaveRequestsRoute
  '/loyalty': typeof AppLoyaltyRoute
  '/manual': typeof AppManualRoute
  '/online-booking': typeof AppOnlineBookingRoute
  '/orders': typeof AppOrdersRoute
  '/pay-method': typeof AppPayMethodRoute
  '/payouts': typeof AppPayoutsRoute
  '/privacy': typeof AppPrivacyRoute
  '/ratings': typeof AppRatingsRoute
  '/receiving-accounts': typeof AppReceivingAccountsRoute
  '/rental-report': typeof AppRentalReportRoute
  '/rentals': typeof AppRentalsRoute
  '/reports': typeof AppReportsRoute
  '/reports-inbox': typeof AppReportsInboxRoute
  '/sales-report': typeof AppSalesReportRoute
  '/sales-summary': typeof AppSalesSummaryRoute
  '/service-records': typeof AppServiceRecordsRoute
  '/setup': typeof AppSetupRoute
  '/staff': typeof AppStaffRoute
  '/tables': typeof AppTablesRoute
  '/today': typeof AppTodayRoute
  '/vacation-test': typeof AppVacationTestRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/approve/$token': typeof ApproveTokenRoute
  '/account/security': typeof AppAccountSecurityRoute
  '/checklists/new': typeof AppChecklistsNewRoute
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/customers/import': typeof AppCustomersImportRoute
  '/help/$topic': typeof AppHelpTopicRoute
  '/imports/pos': typeof AppImportsPosRoute
  '/inventory/import': typeof AppInventoryImportRoute
  '/inventory/ingredients': typeof AppInventoryIngredientsRoute
  '/inventory/products': typeof AppInventoryProductsRoute
  '/inventory/reports': typeof AppInventoryReportsRoute
  '/inventory/sell': typeof AppInventorySellRoute
  '/inventory/stock': typeof AppInventoryStockRoute
  '/me/approval': typeof AppMeApprovalRoute
  '/me/checklists': typeof AppMeChecklistsRoute
  '/me/earnings': typeof AppMeEarningsRoute
  '/me/leave': typeof AppMeLeaveRoute
  '/me/notifications': typeof AppMeNotificationsRoute
  '/me/schedule': typeof AppMeScheduleRoute
  '/me/sops': typeof AppMeSopsRoute
  '/me/today': typeof AppMeTodayRoute
  '/messages/jobs': typeof AppMessagesJobsRoute
  '/messages/plans': typeof AppMessagesPlansRoute
  '/messages/templates': typeof AppMessagesTemplatesRoute
  '/rentals/import': typeof AppRentalsImportRoute
  '/rentals/import-bookings': typeof AppRentalsImportBookingsRoute
  '/rentals/photos': typeof AppRentalsPhotosRoute
  '/rules/booking': typeof AppRulesBookingRoute
  '/rules/compensation': typeof AppRulesCompensationRoute
  '/rules/discount': typeof AppRulesDiscountRoute
  '/settings/ai-chat': typeof AppSettingsAiChatRoute
  '/settings/approvals': typeof AppSettingsApprovalsRoute
  '/settings/branches': typeof AppSettingsBranchesRoute
  '/settings/clinical': typeof AppSettingsClinicalRoute
  '/settings/customers': typeof AppSettingsCustomersRoute
  '/settings/inventory': typeof AppSettingsInventoryRoute
  '/settings/line': typeof AppSettingsLineRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/settings/meta-channels': typeof AppSettingsMetaChannelsRoute
  '/settings/online-booking': typeof AppSettingsOnlineBookingRoute
  '/settings/online-ordering': typeof AppSettingsOnlineOrderingRoute
  '/settings/payments': typeof AppSettingsPaymentsRoute
  '/settings/positions': typeof AppSettingsPositionsRoute
  '/settings/reminders': typeof AppSettingsRemindersRoute
  '/settings/rental': typeof AppSettingsRentalRoute
  '/settings/resources': typeof AppSettingsResourcesRoute
  '/settings/roles': typeof AppSettingsRolesRoute
  '/settings/skills': typeof AppSettingsSkillsRoute
  '/settings/tenant': typeof AppSettingsTenantRoute
  '/shifts/templates': typeof AppShiftsTemplatesRoute
  '/sops/new': typeof AppSopsNewRoute
  '/surveys/$id': typeof AppSurveysIdRoute
  '/team/risk': typeof AppTeamRiskRoute
  '/invite/$token': typeof AuthInviteTokenRoute
  '/pay/$token': typeof PublicPayTokenRoute
  '/r/$code': typeof PublicRCodeRoute
  '/s/$token': typeof PublicSTokenRoute
  '/checklists': typeof AppChecklistsIndexRoute
  '/checkout': typeof AppCheckoutIndexRoute
  '/clinical': typeof AppClinicalIndexRoute
  '/customers': typeof AppCustomersIndexRoute
  '/help': typeof AppHelpIndexRoute
  '/messages': typeof AppMessagesIndexRoute
  '/rules': typeof AppRulesIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/shifts': typeof AppShiftsIndexRoute
  '/sops': typeof AppSopsIndexRoute
  '/surveys': typeof AppSurveysIndexRoute
  '/r': typeof PublicRIndexRoute
  '/checklists/$id/edit': typeof AppChecklistsIdEditRoute
  '/checklists/runs/$runId': typeof AppChecklistsRunsRunIdRoute
  '/checkout/$billId/receipt': typeof AppCheckoutBillIdReceiptRoute
  '/clinical/patients/$customerId': typeof AppClinicalPatientsCustomerIdRoute
  '/inventory/count/$id': typeof AppInventoryCountIdRoute
  '/settings/line/guide': typeof AppSettingsLineGuideRoute
  '/settings/services/import': typeof AppSettingsServicesImportRoute
  '/sops/$id/edit': typeof AppSopsIdEditRoute
  '/team/$id/offboarding': typeof AppTeamIdOffboardingRoute
  '/checkout/$billId': typeof AppCheckoutBillIdIndexRoute
  '/inventory/count': typeof AppInventoryCountIndexRoute
  '/settings/services': typeof AppSettingsServicesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/impersonate': typeof ImpersonateRoute
  '/onboarding': typeof OnboardingRoute
  '/select-tenant': typeof SelectTenantRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_app/ai-chat': typeof AppAiChatRoute
  '/_app/approvals': typeof AppApprovalsRoute
  '/_app/billing': typeof AppBillingRoute
  '/_app/bills': typeof AppBillsRoute
  '/_app/branch-compare': typeof AppBranchCompareRoute
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/cash': typeof AppCashRoute
  '/_app/close-day': typeof AppCloseDayRoute
  '/_app/complaints': typeof AppComplaintsRoute
  '/_app/finance': typeof AppFinanceRoute
  '/_app/followups': typeof AppFollowupsRoute
  '/_app/goals': typeof AppGoalsRoute
  '/_app/health': typeof AppHealthRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/kpi': typeof AppKpiRoute
  '/_app/leave-requests': typeof AppLeaveRequestsRoute
  '/_app/loyalty': typeof AppLoyaltyRoute
  '/_app/manual': typeof AppManualRoute
  '/_app/messages': typeof AppMessagesRouteWithChildren
  '/_app/online-booking': typeof AppOnlineBookingRoute
  '/_app/orders': typeof AppOrdersRoute
  '/_app/pay-method': typeof AppPayMethodRoute
  '/_app/payouts': typeof AppPayoutsRoute
  '/_app/privacy': typeof AppPrivacyRoute
  '/_app/ratings': typeof AppRatingsRoute
  '/_app/receiving-accounts': typeof AppReceivingAccountsRoute
  '/_app/rental-report': typeof AppRentalReportRoute
  '/_app/rentals': typeof AppRentalsRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/reports-inbox': typeof AppReportsInboxRoute
  '/_app/rules': typeof AppRulesRouteWithChildren
  '/_app/sales-report': typeof AppSalesReportRoute
  '/_app/sales-summary': typeof AppSalesSummaryRoute
  '/_app/service-records': typeof AppServiceRecordsRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/setup': typeof AppSetupRoute
  '/_app/staff': typeof AppStaffRoute
  '/_app/tables': typeof AppTablesRoute
  '/_app/today': typeof AppTodayRoute
  '/_app/vacation-test': typeof AppVacationTestRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/approve/$token': typeof ApproveTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/account/security': typeof AppAccountSecurityRoute
  '/_app/checklists/new': typeof AppChecklistsNewRoute
  '/_app/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/_app/customers/import': typeof AppCustomersImportRoute
  '/_app/help/$topic': typeof AppHelpTopicRoute
  '/_app/imports/pos': typeof AppImportsPosRoute
  '/_app/inventory/import': typeof AppInventoryImportRoute
  '/_app/inventory/ingredients': typeof AppInventoryIngredientsRoute
  '/_app/inventory/products': typeof AppInventoryProductsRoute
  '/_app/inventory/reports': typeof AppInventoryReportsRoute
  '/_app/inventory/sell': typeof AppInventorySellRoute
  '/_app/inventory/stock': typeof AppInventoryStockRoute
  '/_app/me/approval': typeof AppMeApprovalRoute
  '/_app/me/checklists': typeof AppMeChecklistsRoute
  '/_app/me/earnings': typeof AppMeEarningsRoute
  '/_app/me/leave': typeof AppMeLeaveRoute
  '/_app/me/notifications': typeof AppMeNotificationsRoute
  '/_app/me/schedule': typeof AppMeScheduleRoute
  '/_app/me/sops': typeof AppMeSopsRoute
  '/_app/me/today': typeof AppMeTodayRoute
  '/_app/messages/jobs': typeof AppMessagesJobsRoute
  '/_app/messages/plans': typeof AppMessagesPlansRoute
  '/_app/messages/templates': typeof AppMessagesTemplatesRoute
  '/_app/rentals_/import': typeof AppRentalsImportRoute
  '/_app/rentals_/import-bookings': typeof AppRentalsImportBookingsRoute
  '/_app/rentals_/photos': typeof AppRentalsPhotosRoute
  '/_app/rules/booking': typeof AppRulesBookingRoute
  '/_app/rules/compensation': typeof AppRulesCompensationRoute
  '/_app/rules/discount': typeof AppRulesDiscountRoute
  '/_app/settings/ai-chat': typeof AppSettingsAiChatRoute
  '/_app/settings/approvals': typeof AppSettingsApprovalsRoute
  '/_app/settings/branches': typeof AppSettingsBranchesRoute
  '/_app/settings/clinical': typeof AppSettingsClinicalRoute
  '/_app/settings/customers': typeof AppSettingsCustomersRoute
  '/_app/settings/inventory': typeof AppSettingsInventoryRoute
  '/_app/settings/line': typeof AppSettingsLineRoute
  '/_app/settings/members': typeof AppSettingsMembersRoute
  '/_app/settings/meta-channels': typeof AppSettingsMetaChannelsRoute
  '/_app/settings/online-booking': typeof AppSettingsOnlineBookingRoute
  '/_app/settings/online-ordering': typeof AppSettingsOnlineOrderingRoute
  '/_app/settings/payments': typeof AppSettingsPaymentsRoute
  '/_app/settings/positions': typeof AppSettingsPositionsRoute
  '/_app/settings/reminders': typeof AppSettingsRemindersRoute
  '/_app/settings/rental': typeof AppSettingsRentalRoute
  '/_app/settings/resources': typeof AppSettingsResourcesRoute
  '/_app/settings/roles': typeof AppSettingsRolesRoute
  '/_app/settings/skills': typeof AppSettingsSkillsRoute
  '/_app/settings/tenant': typeof AppSettingsTenantRoute
  '/_app/shifts/templates': typeof AppShiftsTemplatesRoute
  '/_app/sops/new': typeof AppSopsNewRoute
  '/_app/surveys/$id': typeof AppSurveysIdRoute
  '/_app/team/risk': typeof AppTeamRiskRoute
  '/_auth/invite/$token': typeof AuthInviteTokenRoute
  '/_public/pay/$token': typeof PublicPayTokenRoute
  '/_public/r/$code': typeof PublicRCodeRoute
  '/_public/s/$token': typeof PublicSTokenRoute
  '/_app/checklists/': typeof AppChecklistsIndexRoute
  '/_app/checkout/': typeof AppCheckoutIndexRoute
  '/_app/clinical/': typeof AppClinicalIndexRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/help/': typeof AppHelpIndexRoute
  '/_app/messages/': typeof AppMessagesIndexRoute
  '/_app/rules/': typeof AppRulesIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/shifts/': typeof AppShiftsIndexRoute
  '/_app/sops/': typeof AppSopsIndexRoute
  '/_app/surveys/': typeof AppSurveysIndexRoute
  '/_public/r/': typeof PublicRIndexRoute
  '/_app/checklists/$id/edit': typeof AppChecklistsIdEditRoute
  '/_app/checklists/runs/$runId': typeof AppChecklistsRunsRunIdRoute
  '/_app/checkout/$billId/receipt': typeof AppCheckoutBillIdReceiptRoute
  '/_app/clinical/patients/$customerId': typeof AppClinicalPatientsCustomerIdRoute
  '/_app/inventory/count/$id': typeof AppInventoryCountIdRoute
  '/_app/settings/line_/guide': typeof AppSettingsLineGuideRoute
  '/_app/settings/services/import': typeof AppSettingsServicesImportRoute
  '/_app/sops/$id/edit': typeof AppSopsIdEditRoute
  '/_app/team/$id/offboarding': typeof AppTeamIdOffboardingRoute
  '/_app/checkout/$billId/': typeof AppCheckoutBillIdIndexRoute
  '/_app/inventory/count/': typeof AppInventoryCountIndexRoute
  '/_app/settings/services/': typeof AppSettingsServicesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/impersonate'
    | '/onboarding'
    | '/select-tenant'
    | '/verify-email'
    | '/ai-chat'
    | '/approvals'
    | '/billing'
    | '/bills'
    | '/branch-compare'
    | '/calendar'
    | '/cash'
    | '/close-day'
    | '/complaints'
    | '/finance'
    | '/followups'
    | '/goals'
    | '/health'
    | '/inbox'
    | '/kpi'
    | '/leave-requests'
    | '/loyalty'
    | '/manual'
    | '/messages'
    | '/online-booking'
    | '/orders'
    | '/pay-method'
    | '/payouts'
    | '/privacy'
    | '/ratings'
    | '/receiving-accounts'
    | '/rental-report'
    | '/rentals'
    | '/reports'
    | '/reports-inbox'
    | '/rules'
    | '/sales-report'
    | '/sales-summary'
    | '/service-records'
    | '/settings'
    | '/setup'
    | '/staff'
    | '/tables'
    | '/today'
    | '/vacation-test'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/approve/$token'
    | '/account/security'
    | '/checklists/new'
    | '/customers/$customerId'
    | '/customers/import'
    | '/help/$topic'
    | '/imports/pos'
    | '/inventory/import'
    | '/inventory/ingredients'
    | '/inventory/products'
    | '/inventory/reports'
    | '/inventory/sell'
    | '/inventory/stock'
    | '/me/approval'
    | '/me/checklists'
    | '/me/earnings'
    | '/me/leave'
    | '/me/notifications'
    | '/me/schedule'
    | '/me/sops'
    | '/me/today'
    | '/messages/jobs'
    | '/messages/plans'
    | '/messages/templates'
    | '/rentals/import'
    | '/rentals/import-bookings'
    | '/rentals/photos'
    | '/rules/booking'
    | '/rules/compensation'
    | '/rules/discount'
    | '/settings/ai-chat'
    | '/settings/approvals'
    | '/settings/branches'
    | '/settings/clinical'
    | '/settings/customers'
    | '/settings/inventory'
    | '/settings/line'
    | '/settings/members'
    | '/settings/meta-channels'
    | '/settings/online-booking'
    | '/settings/online-ordering'
    | '/settings/payments'
    | '/settings/positions'
    | '/settings/reminders'
    | '/settings/rental'
    | '/settings/resources'
    | '/settings/roles'
    | '/settings/skills'
    | '/settings/tenant'
    | '/shifts/templates'
    | '/sops/new'
    | '/surveys/$id'
    | '/team/risk'
    | '/invite/$token'
    | '/pay/$token'
    | '/r/$code'
    | '/s/$token'
    | '/checklists/'
    | '/checkout/'
    | '/clinical/'
    | '/customers/'
    | '/help/'
    | '/messages/'
    | '/rules/'
    | '/settings/'
    | '/shifts/'
    | '/sops/'
    | '/surveys/'
    | '/r/'
    | '/checklists/$id/edit'
    | '/checklists/runs/$runId'
    | '/checkout/$billId/receipt'
    | '/clinical/patients/$customerId'
    | '/inventory/count/$id'
    | '/settings/line/guide'
    | '/settings/services/import'
    | '/sops/$id/edit'
    | '/team/$id/offboarding'
    | '/checkout/$billId/'
    | '/inventory/count/'
    | '/settings/services/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/impersonate'
    | '/onboarding'
    | '/select-tenant'
    | '/verify-email'
    | '/ai-chat'
    | '/approvals'
    | '/billing'
    | '/bills'
    | '/branch-compare'
    | '/calendar'
    | '/cash'
    | '/close-day'
    | '/complaints'
    | '/finance'
    | '/followups'
    | '/goals'
    | '/health'
    | '/inbox'
    | '/kpi'
    | '/leave-requests'
    | '/loyalty'
    | '/manual'
    | '/online-booking'
    | '/orders'
    | '/pay-method'
    | '/payouts'
    | '/privacy'
    | '/ratings'
    | '/receiving-accounts'
    | '/rental-report'
    | '/rentals'
    | '/reports'
    | '/reports-inbox'
    | '/sales-report'
    | '/sales-summary'
    | '/service-records'
    | '/setup'
    | '/staff'
    | '/tables'
    | '/today'
    | '/vacation-test'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/approve/$token'
    | '/account/security'
    | '/checklists/new'
    | '/customers/$customerId'
    | '/customers/import'
    | '/help/$topic'
    | '/imports/pos'
    | '/inventory/import'
    | '/inventory/ingredients'
    | '/inventory/products'
    | '/inventory/reports'
    | '/inventory/sell'
    | '/inventory/stock'
    | '/me/approval'
    | '/me/checklists'
    | '/me/earnings'
    | '/me/leave'
    | '/me/notifications'
    | '/me/schedule'
    | '/me/sops'
    | '/me/today'
    | '/messages/jobs'
    | '/messages/plans'
    | '/messages/templates'
    | '/rentals/import'
    | '/rentals/import-bookings'
    | '/rentals/photos'
    | '/rules/booking'
    | '/rules/compensation'
    | '/rules/discount'
    | '/settings/ai-chat'
    | '/settings/approvals'
    | '/settings/branches'
    | '/settings/clinical'
    | '/settings/customers'
    | '/settings/inventory'
    | '/settings/line'
    | '/settings/members'
    | '/settings/meta-channels'
    | '/settings/online-booking'
    | '/settings/online-ordering'
    | '/settings/payments'
    | '/settings/positions'
    | '/settings/reminders'
    | '/settings/rental'
    | '/settings/resources'
    | '/settings/roles'
    | '/settings/skills'
    | '/settings/tenant'
    | '/shifts/templates'
    | '/sops/new'
    | '/surveys/$id'
    | '/team/risk'
    | '/invite/$token'
    | '/pay/$token'
    | '/r/$code'
    | '/s/$token'
    | '/checklists'
    | '/checkout'
    | '/clinical'
    | '/customers'
    | '/help'
    | '/messages'
    | '/rules'
    | '/settings'
    | '/shifts'
    | '/sops'
    | '/surveys'
    | '/r'
    | '/checklists/$id/edit'
    | '/checklists/runs/$runId'
    | '/checkout/$billId/receipt'
    | '/clinical/patients/$customerId'
    | '/inventory/count/$id'
    | '/settings/line/guide'
    | '/settings/services/import'
    | '/sops/$id/edit'
    | '/team/$id/offboarding'
    | '/checkout/$billId'
    | '/inventory/count'
    | '/settings/services'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_public'
    | '/impersonate'
    | '/onboarding'
    | '/select-tenant'
    | '/verify-email'
    | '/_app/ai-chat'
    | '/_app/approvals'
    | '/_app/billing'
    | '/_app/bills'
    | '/_app/branch-compare'
    | '/_app/calendar'
    | '/_app/cash'
    | '/_app/close-day'
    | '/_app/complaints'
    | '/_app/finance'
    | '/_app/followups'
    | '/_app/goals'
    | '/_app/health'
    | '/_app/inbox'
    | '/_app/kpi'
    | '/_app/leave-requests'
    | '/_app/loyalty'
    | '/_app/manual'
    | '/_app/messages'
    | '/_app/online-booking'
    | '/_app/orders'
    | '/_app/pay-method'
    | '/_app/payouts'
    | '/_app/privacy'
    | '/_app/ratings'
    | '/_app/receiving-accounts'
    | '/_app/rental-report'
    | '/_app/rentals'
    | '/_app/reports'
    | '/_app/reports-inbox'
    | '/_app/rules'
    | '/_app/sales-report'
    | '/_app/sales-summary'
    | '/_app/service-records'
    | '/_app/settings'
    | '/_app/setup'
    | '/_app/staff'
    | '/_app/tables'
    | '/_app/today'
    | '/_app/vacation-test'
    | '/_auth/forgot-password'
    | '/_auth/reset-password'
    | '/_auth/sign-in'
    | '/_auth/sign-up'
    | '/approve/$token'
    | '/_app/'
    | '/_app/account/security'
    | '/_app/checklists/new'
    | '/_app/customers/$customerId'
    | '/_app/customers/import'
    | '/_app/help/$topic'
    | '/_app/imports/pos'
    | '/_app/inventory/import'
    | '/_app/inventory/ingredients'
    | '/_app/inventory/products'
    | '/_app/inventory/reports'
    | '/_app/inventory/sell'
    | '/_app/inventory/stock'
    | '/_app/me/approval'
    | '/_app/me/checklists'
    | '/_app/me/earnings'
    | '/_app/me/leave'
    | '/_app/me/notifications'
    | '/_app/me/schedule'
    | '/_app/me/sops'
    | '/_app/me/today'
    | '/_app/messages/jobs'
    | '/_app/messages/plans'
    | '/_app/messages/templates'
    | '/_app/rentals_/import'
    | '/_app/rentals_/import-bookings'
    | '/_app/rentals_/photos'
    | '/_app/rules/booking'
    | '/_app/rules/compensation'
    | '/_app/rules/discount'
    | '/_app/settings/ai-chat'
    | '/_app/settings/approvals'
    | '/_app/settings/branches'
    | '/_app/settings/clinical'
    | '/_app/settings/customers'
    | '/_app/settings/inventory'
    | '/_app/settings/line'
    | '/_app/settings/members'
    | '/_app/settings/meta-channels'
    | '/_app/settings/online-booking'
    | '/_app/settings/online-ordering'
    | '/_app/settings/payments'
    | '/_app/settings/positions'
    | '/_app/settings/reminders'
    | '/_app/settings/rental'
    | '/_app/settings/resources'
    | '/_app/settings/roles'
    | '/_app/settings/skills'
    | '/_app/settings/tenant'
    | '/_app/shifts/templates'
    | '/_app/sops/new'
    | '/_app/surveys/$id'
    | '/_app/team/risk'
    | '/_auth/invite/$token'
    | '/_public/pay/$token'
    | '/_public/r/$code'
    | '/_public/s/$token'
    | '/_app/checklists/'
    | '/_app/checkout/'
    | '/_app/clinical/'
    | '/_app/customers/'
    | '/_app/help/'
    | '/_app/messages/'
    | '/_app/rules/'
    | '/_app/settings/'
    | '/_app/shifts/'
    | '/_app/sops/'
    | '/_app/surveys/'
    | '/_public/r/'
    | '/_app/checklists/$id/edit'
    | '/_app/checklists/runs/$runId'
    | '/_app/checkout/$billId/receipt'
    | '/_app/clinical/patients/$customerId'
    | '/_app/inventory/count/$id'
    | '/_app/settings/line_/guide'
    | '/_app/settings/services/import'
    | '/_app/sops/$id/edit'
    | '/_app/team/$id/offboarding'
    | '/_app/checkout/$billId/'
    | '/_app/inventory/count/'
    | '/_app/settings/services/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  ImpersonateRoute: typeof ImpersonateRoute
  OnboardingRoute: typeof OnboardingRoute
  SelectTenantRoute: typeof SelectTenantRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  ApproveTokenRoute: typeof ApproveTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/select-tenant': {
      id: '/select-tenant'
      path: '/select-tenant'
      fullPath: '/select-tenant'
      preLoaderRoute: typeof SelectTenantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ai-chat': {
      id: '/_app/ai-chat'
      path: '/ai-chat'
      fullPath: '/ai-chat'
      preLoaderRoute: typeof AppAiChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approvals': {
      id: '/_app/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof AppApprovalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing': {
      id: '/_app/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bills': {
      id: '/_app/bills'
      path: '/bills'
      fullPath: '/bills'
      preLoaderRoute: typeof AppBillsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/branch-compare': {
      id: '/_app/branch-compare'
      path: '/branch-compare'
      fullPath: '/branch-compare'
      preLoaderRoute: typeof AppBranchCompareRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cash': {
      id: '/_app/cash'
      path: '/cash'
      fullPath: '/cash'
      preLoaderRoute: typeof AppCashRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/close-day': {
      id: '/_app/close-day'
      path: '/close-day'
      fullPath: '/close-day'
      preLoaderRoute: typeof AppCloseDayRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/complaints': {
      id: '/_app/complaints'
      path: '/complaints'
      fullPath: '/complaints'
      preLoaderRoute: typeof AppComplaintsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance': {
      id: '/_app/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof AppFinanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/followups': {
      id: '/_app/followups'
      path: '/followups'
      fullPath: '/followups'
      preLoaderRoute: typeof AppFollowupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/goals': {
      id: '/_app/goals'
      path: '/goals'
      fullPath: '/goals'
      preLoaderRoute: typeof AppGoalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/health': {
      id: '/_app/health'
      path: '/health'
      fullPath: '/health'
      preLoaderRoute: typeof AppHealthRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kpi': {
      id: '/_app/kpi'
      path: '/kpi'
      fullPath: '/kpi'
      preLoaderRoute: typeof AppKpiRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leave-requests': {
      id: '/_app/leave-requests'
      path: '/leave-requests'
      fullPath: '/leave-requests'
      preLoaderRoute: typeof AppLeaveRequestsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/loyalty': {
      id: '/_app/loyalty'
      path: '/loyalty'
      fullPath: '/loyalty'
      preLoaderRoute: typeof AppLoyaltyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/manual': {
      id: '/_app/manual'
      path: '/manual'
      fullPath: '/manual'
      preLoaderRoute: typeof AppManualRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages': {
      id: '/_app/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AppMessagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/online-booking': {
      id: '/_app/online-booking'
      path: '/online-booking'
      fullPath: '/online-booking'
      preLoaderRoute: typeof AppOnlineBookingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders': {
      id: '/_app/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AppOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pay-method': {
      id: '/_app/pay-method'
      path: '/pay-method'
      fullPath: '/pay-method'
      preLoaderRoute: typeof AppPayMethodRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payouts': {
      id: '/_app/payouts'
      path: '/payouts'
      fullPath: '/payouts'
      preLoaderRoute: typeof AppPayoutsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/privacy': {
      id: '/_app/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof AppPrivacyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ratings': {
      id: '/_app/ratings'
      path: '/ratings'
      fullPath: '/ratings'
      preLoaderRoute: typeof AppRatingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/receiving-accounts': {
      id: '/_app/receiving-accounts'
      path: '/receiving-accounts'
      fullPath: '/receiving-accounts'
      preLoaderRoute: typeof AppReceivingAccountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rental-report': {
      id: '/_app/rental-report'
      path: '/rental-report'
      fullPath: '/rental-report'
      preLoaderRoute: typeof AppRentalReportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rentals': {
      id: '/_app/rentals'
      path: '/rentals'
      fullPath: '/rentals'
      preLoaderRoute: typeof AppRentalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports-inbox': {
      id: '/_app/reports-inbox'
      path: '/reports-inbox'
      fullPath: '/reports-inbox'
      preLoaderRoute: typeof AppReportsInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rules': {
      id: '/_app/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof AppRulesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales-report': {
      id: '/_app/sales-report'
      path: '/sales-report'
      fullPath: '/sales-report'
      preLoaderRoute: typeof AppSalesReportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales-summary': {
      id: '/_app/sales-summary'
      path: '/sales-summary'
      fullPath: '/sales-summary'
      preLoaderRoute: typeof AppSalesSummaryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/service-records': {
      id: '/_app/service-records'
      path: '/service-records'
      fullPath: '/service-records'
      preLoaderRoute: typeof AppServiceRecordsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/setup': {
      id: '/_app/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof AppSetupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/staff': {
      id: '/_app/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof AppStaffRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tables': {
      id: '/_app/tables'
      path: '/tables'
      fullPath: '/tables'
      preLoaderRoute: typeof AppTablesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/today': {
      id: '/_app/today'
      path: '/today'
      fullPath: '/today'
      preLoaderRoute: typeof AppTodayRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vacation-test': {
      id: '/_app/vacation-test'
      path: '/vacation-test'
      fullPath: '/vacation-test'
      preLoaderRoute: typeof AppVacationTestRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/approve/$token': {
      id: '/approve/$token'
      path: '/approve/$token'
      fullPath: '/approve/$token'
      preLoaderRoute: typeof ApproveTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/account/security': {
      id: '/_app/account/security'
      path: '/account/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof AppAccountSecurityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/checklists/': {
      id: '/_app/checklists/'
      path: '/checklists'
      fullPath: '/checklists/'
      preLoaderRoute: typeof AppChecklistsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/checklists/new': {
      id: '/_app/checklists/new'
      path: '/checklists/new'
      fullPath: '/checklists/new'
      preLoaderRoute: typeof AppChecklistsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/checkout/': {
      id: '/_app/checkout/'
      path: '/checkout'
      fullPath: '/checkout/'
      preLoaderRoute: typeof AppCheckoutIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clinical/': {
      id: '/_app/clinical/'
      path: '/clinical'
      fullPath: '/clinical/'
      preLoaderRoute: typeof AppClinicalIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/$customerId': {
      id: '/_app/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AppCustomersCustomerIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/import': {
      id: '/_app/customers/import'
      path: '/customers/import'
      fullPath: '/customers/import'
      preLoaderRoute: typeof AppCustomersImportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/': {
      id: '/_app/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof AppHelpIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/$topic': {
      id: '/_app/help/$topic'
      path: '/help/$topic'
      fullPath: '/help/$topic'
      preLoaderRoute: typeof AppHelpTopicRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/imports/pos': {
      id: '/_app/imports/pos'
      path: '/imports/pos'
      fullPath: '/imports/pos'
      preLoaderRoute: typeof AppImportsPosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/import': {
      id: '/_app/inventory/import'
      path: '/inventory/import'
      fullPath: '/inventory/import'
      preLoaderRoute: typeof AppInventoryImportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/ingredients': {
      id: '/_app/inventory/ingredients'
      path: '/inventory/ingredients'
      fullPath: '/inventory/ingredients'
      preLoaderRoute: typeof AppInventoryIngredientsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/products': {
      id: '/_app/inventory/products'
      path: '/inventory/products'
      fullPath: '/inventory/products'
      preLoaderRoute: typeof AppInventoryProductsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/reports': {
      id: '/_app/inventory/reports'
      path: '/inventory/reports'
      fullPath: '/inventory/reports'
      preLoaderRoute: typeof AppInventoryReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/sell': {
      id: '/_app/inventory/sell'
      path: '/inventory/sell'
      fullPath: '/inventory/sell'
      preLoaderRoute: typeof AppInventorySellRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/stock': {
      id: '/_app/inventory/stock'
      path: '/inventory/stock'
      fullPath: '/inventory/stock'
      preLoaderRoute: typeof AppInventoryStockRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/approval': {
      id: '/_app/me/approval'
      path: '/me/approval'
      fullPath: '/me/approval'
      preLoaderRoute: typeof AppMeApprovalRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/checklists': {
      id: '/_app/me/checklists'
      path: '/me/checklists'
      fullPath: '/me/checklists'
      preLoaderRoute: typeof AppMeChecklistsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/earnings': {
      id: '/_app/me/earnings'
      path: '/me/earnings'
      fullPath: '/me/earnings'
      preLoaderRoute: typeof AppMeEarningsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/leave': {
      id: '/_app/me/leave'
      path: '/me/leave'
      fullPath: '/me/leave'
      preLoaderRoute: typeof AppMeLeaveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/notifications': {
      id: '/_app/me/notifications'
      path: '/me/notifications'
      fullPath: '/me/notifications'
      preLoaderRoute: typeof AppMeNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/schedule': {
      id: '/_app/me/schedule'
      path: '/me/schedule'
      fullPath: '/me/schedule'
      preLoaderRoute: typeof AppMeScheduleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/sops': {
      id: '/_app/me/sops'
      path: '/me/sops'
      fullPath: '/me/sops'
      preLoaderRoute: typeof AppMeSopsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/today': {
      id: '/_app/me/today'
      path: '/me/today'
      fullPath: '/me/today'
      preLoaderRoute: typeof AppMeTodayRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages/': {
      id: '/_app/messages/'
      path: '/'
      fullPath: '/messages/'
      preLoaderRoute: typeof AppMessagesIndexRouteImport
      parentRoute: typeof AppMessagesRoute
    }
    '/_app/messages/jobs': {
      id: '/_app/messages/jobs'
      path: '/jobs'
      fullPath: '/messages/jobs'
      preLoaderRoute: typeof AppMessagesJobsRouteImport
      parentRoute: typeof AppMessagesRoute
    }
    '/_app/messages/plans': {
      id: '/_app/messages/plans'
      path: '/plans'
      fullPath: '/messages/plans'
      preLoaderRoute: typeof AppMessagesPlansRouteImport
      parentRoute: typeof AppMessagesRoute
    }
    '/_app/messages/templates': {
      id: '/_app/messages/templates'
      path: '/templates'
      fullPath: '/messages/templates'
      preLoaderRoute: typeof AppMessagesTemplatesRouteImport
      parentRoute: typeof AppMessagesRoute
    }
    '/_app/rentals_/import': {
      id: '/_app/rentals_/import'
      path: '/rentals/import'
      fullPath: '/rentals/import'
      preLoaderRoute: typeof AppRentalsImportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rentals_/import-bookings': {
      id: '/_app/rentals_/import-bookings'
      path: '/rentals/import-bookings'
      fullPath: '/rentals/import-bookings'
      preLoaderRoute: typeof AppRentalsImportBookingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rentals_/photos': {
      id: '/_app/rentals_/photos'
      path: '/rentals/photos'
      fullPath: '/rentals/photos'
      preLoaderRoute: typeof AppRentalsPhotosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rules/': {
      id: '/_app/rules/'
      path: '/'
      fullPath: '/rules/'
      preLoaderRoute: typeof AppRulesIndexRouteImport
      parentRoute: typeof AppRulesRoute
    }
    '/_app/rules/booking': {
      id: '/_app/rules/booking'
      path: '/booking'
      fullPath: '/rules/booking'
      preLoaderRoute: typeof AppRulesBookingRouteImport
      parentRoute: typeof AppRulesRoute
    }
    '/_app/rules/compensation': {
      id: '/_app/rules/compensation'
      path: '/compensation'
      fullPath: '/rules/compensation'
      preLoaderRoute: typeof AppRulesCompensationRouteImport
      parentRoute: typeof AppRulesRoute
    }
    '/_app/rules/discount': {
      id: '/_app/rules/discount'
      path: '/discount'
      fullPath: '/rules/discount'
      preLoaderRoute: typeof AppRulesDiscountRouteImport
      parentRoute: typeof AppRulesRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/ai-chat': {
      id: '/_app/settings/ai-chat'
      path: '/ai-chat'
      fullPath: '/settings/ai-chat'
      preLoaderRoute: typeof AppSettingsAiChatRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/approvals': {
      id: '/_app/settings/approvals'
      path: '/approvals'
      fullPath: '/settings/approvals'
      preLoaderRoute: typeof AppSettingsApprovalsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/branches': {
      id: '/_app/settings/branches'
      path: '/branches'
      fullPath: '/settings/branches'
      preLoaderRoute: typeof AppSettingsBranchesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/clinical': {
      id: '/_app/settings/clinical'
      path: '/clinical'
      fullPath: '/settings/clinical'
      preLoaderRoute: typeof AppSettingsClinicalRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/customers': {
      id: '/_app/settings/customers'
      path: '/customers'
      fullPath: '/settings/customers'
      preLoaderRoute: typeof AppSettingsCustomersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/inventory': {
      id: '/_app/settings/inventory'
      path: '/inventory'
      fullPath: '/settings/inventory'
      preLoaderRoute: typeof AppSettingsInventoryRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/line': {
      id: '/_app/settings/line'
      path: '/line'
      fullPath: '/settings/line'
      preLoaderRoute: typeof AppSettingsLineRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/members': {
      id: '/_app/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AppSettingsMembersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/meta-channels': {
      id: '/_app/settings/meta-channels'
      path: '/meta-channels'
      fullPath: '/settings/meta-channels'
      preLoaderRoute: typeof AppSettingsMetaChannelsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/online-booking': {
      id: '/_app/settings/online-booking'
      path: '/online-booking'
      fullPath: '/settings/online-booking'
      preLoaderRoute: typeof AppSettingsOnlineBookingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/online-ordering': {
      id: '/_app/settings/online-ordering'
      path: '/online-ordering'
      fullPath: '/settings/online-ordering'
      preLoaderRoute: typeof AppSettingsOnlineOrderingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/payments': {
      id: '/_app/settings/payments'
      path: '/payments'
      fullPath: '/settings/payments'
      preLoaderRoute: typeof AppSettingsPaymentsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/positions': {
      id: '/_app/settings/positions'
      path: '/positions'
      fullPath: '/settings/positions'
      preLoaderRoute: typeof AppSettingsPositionsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/reminders': {
      id: '/_app/settings/reminders'
      path: '/reminders'
      fullPath: '/settings/reminders'
      preLoaderRoute: typeof AppSettingsRemindersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/rental': {
      id: '/_app/settings/rental'
      path: '/rental'
      fullPath: '/settings/rental'
      preLoaderRoute: typeof AppSettingsRentalRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/resources': {
      id: '/_app/settings/resources'
      path: '/resources'
      fullPath: '/settings/resources'
      preLoaderRoute: typeof AppSettingsResourcesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/roles': {
      id: '/_app/settings/roles'
      path: '/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AppSettingsRolesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/skills': {
      id: '/_app/settings/skills'
      path: '/skills'
      fullPath: '/settings/skills'
      preLoaderRoute: typeof AppSettingsSkillsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/tenant': {
      id: '/_app/settings/tenant'
      path: '/tenant'
      fullPath: '/settings/tenant'
      preLoaderRoute: typeof AppSettingsTenantRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/shifts/': {
      id: '/_app/shifts/'
      path: '/shifts'
      fullPath: '/shifts/'
      preLoaderRoute: typeof AppShiftsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shifts/templates': {
      id: '/_app/shifts/templates'
      path: '/shifts/templates'
      fullPath: '/shifts/templates'
      preLoaderRoute: typeof AppShiftsTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sops/': {
      id: '/_app/sops/'
      path: '/sops'
      fullPath: '/sops/'
      preLoaderRoute: typeof AppSopsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sops/new': {
      id: '/_app/sops/new'
      path: '/sops/new'
      fullPath: '/sops/new'
      preLoaderRoute: typeof AppSopsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/surveys/': {
      id: '/_app/surveys/'
      path: '/surveys'
      fullPath: '/surveys/'
      preLoaderRoute: typeof AppSurveysIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/surveys/$id': {
      id: '/_app/surveys/$id'
      path: '/surveys/$id'
      fullPath: '/surveys/$id'
      preLoaderRoute: typeof AppSurveysIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team/risk': {
      id: '/_app/team/risk'
      path: '/team/risk'
      fullPath: '/team/risk'
      preLoaderRoute: typeof AppTeamRiskRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/invite/$token': {
      id: '/_auth/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof AuthInviteTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_public/pay/$token': {
      id: '/_public/pay/$token'
      path: '/pay/$token'
      fullPath: '/pay/$token'
      preLoaderRoute: typeof PublicPayTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/r/': {
      id: '/_public/r/'
      path: '/r'
      fullPath: '/r/'
      preLoaderRoute: typeof PublicRIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/r/$code': {
      id: '/_public/r/$code'
      path: '/r/$code'
      fullPath: '/r/$code'
      preLoaderRoute: typeof PublicRCodeRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/s/$token': {
      id: '/_public/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof PublicSTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_app/checklists/$id/edit': {
      id: '/_app/checklists/$id/edit'
      path: '/checklists/$id/edit'
      fullPath: '/checklists/$id/edit'
      preLoaderRoute: typeof AppChecklistsIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/checklists/runs/$runId': {
      id: '/_app/checklists/runs/$runId'
      path: '/checklists/runs/$runId'
      fullPath: '/checklists/runs/$runId'
      preLoaderRoute: typeof AppChecklistsRunsRunIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/checkout/$billId/': {
      id: '/_app/checkout/$billId/'
      path: '/checkout/$billId'
      fullPath: '/checkout/$billId/'
      preLoaderRoute: typeof AppCheckoutBillIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/checkout/$billId/receipt': {
      id: '/_app/checkout/$billId/receipt'
      path: '/checkout/$billId/receipt'
      fullPath: '/checkout/$billId/receipt'
      preLoaderRoute: typeof AppCheckoutBillIdReceiptRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clinical/patients/$customerId': {
      id: '/_app/clinical/patients/$customerId'
      path: '/clinical/patients/$customerId'
      fullPath: '/clinical/patients/$customerId'
      preLoaderRoute: typeof AppClinicalPatientsCustomerIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/count/': {
      id: '/_app/inventory/count/'
      path: '/inventory/count'
      fullPath: '/inventory/count/'
      preLoaderRoute: typeof AppInventoryCountIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/count/$id': {
      id: '/_app/inventory/count/$id'
      path: '/inventory/count/$id'
      fullPath: '/inventory/count/$id'
      preLoaderRoute: typeof AppInventoryCountIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/line_/guide': {
      id: '/_app/settings/line_/guide'
      path: '/line/guide'
      fullPath: '/settings/line/guide'
      preLoaderRoute: typeof AppSettingsLineGuideRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/services/': {
      id: '/_app/settings/services/'
      path: '/services'
      fullPath: '/settings/services/'
      preLoaderRoute: typeof AppSettingsServicesIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/services/import': {
      id: '/_app/settings/services/import'
      path: '/services/import'
      fullPath: '/settings/services/import'
      preLoaderRoute: typeof AppSettingsServicesImportRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/sops/$id/edit': {
      id: '/_app/sops/$id/edit'
      path: '/sops/$id/edit'
      fullPath: '/sops/$id/edit'
      preLoaderRoute: typeof AppSopsIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team/$id/offboarding': {
      id: '/_app/team/$id/offboarding'
      path: '/team/$id/offboarding'
      fullPath: '/team/$id/offboarding'
      preLoaderRoute: typeof AppTeamIdOffboardingRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppMessagesRouteChildren {
  AppMessagesJobsRoute: typeof AppMessagesJobsRoute
  AppMessagesPlansRoute: typeof AppMessagesPlansRoute
  AppMessagesTemplatesRoute: typeof AppMessagesTemplatesRoute
  AppMessagesIndexRoute: typeof AppMessagesIndexRoute
}

const AppMessagesRouteChildren: AppMessagesRouteChildren = {
  AppMessagesJobsRoute: AppMessagesJobsRoute,
  AppMessagesPlansRoute: AppMessagesPlansRoute,
  AppMessagesTemplatesRoute: AppMessagesTemplatesRoute,
  AppMessagesIndexRoute: AppMessagesIndexRoute,
}

const AppMessagesRouteWithChildren = AppMessagesRoute._addFileChildren(
  AppMessagesRouteChildren,
)

interface AppRulesRouteChildren {
  AppRulesBookingRoute: typeof AppRulesBookingRoute
  AppRulesCompensationRoute: typeof AppRulesCompensationRoute
  AppRulesDiscountRoute: typeof AppRulesDiscountRoute
  AppRulesIndexRoute: typeof AppRulesIndexRoute
}

const AppRulesRouteChildren: AppRulesRouteChildren = {
  AppRulesBookingRoute: AppRulesBookingRoute,
  AppRulesCompensationRoute: AppRulesCompensationRoute,
  AppRulesDiscountRoute: AppRulesDiscountRoute,
  AppRulesIndexRoute: AppRulesIndexRoute,
}

const AppRulesRouteWithChildren = AppRulesRoute._addFileChildren(
  AppRulesRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsAiChatRoute: typeof AppSettingsAiChatRoute
  AppSettingsApprovalsRoute: typeof AppSettingsApprovalsRoute
  AppSettingsBranchesRoute: typeof AppSettingsBranchesRoute
  AppSettingsClinicalRoute: typeof AppSettingsClinicalRoute
  AppSettingsCustomersRoute: typeof AppSettingsCustomersRoute
  AppSettingsInventoryRoute: typeof AppSettingsInventoryRoute
  AppSettingsLineRoute: typeof AppSettingsLineRoute
  AppSettingsMembersRoute: typeof AppSettingsMembersRoute
  AppSettingsMetaChannelsRoute: typeof AppSettingsMetaChannelsRoute
  AppSettingsOnlineBookingRoute: typeof AppSettingsOnlineBookingRoute
  AppSettingsOnlineOrderingRoute: typeof AppSettingsOnlineOrderingRoute
  AppSettingsPaymentsRoute: typeof AppSettingsPaymentsRoute
  AppSettingsPositionsRoute: typeof AppSettingsPositionsRoute
  AppSettingsRemindersRoute: typeof AppSettingsRemindersRoute
  AppSettingsRentalRoute: typeof AppSettingsRentalRoute
  AppSettingsResourcesRoute: typeof AppSettingsResourcesRoute
  AppSettingsRolesRoute: typeof AppSettingsRolesRoute
  AppSettingsSkillsRoute: typeof AppSettingsSkillsRoute
  AppSettingsTenantRoute: typeof AppSettingsTenantRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsLineGuideRoute: typeof AppSettingsLineGuideRoute
  AppSettingsServicesImportRoute: typeof AppSettingsServicesImportRoute
  AppSettingsServicesIndexRoute: typeof AppSettingsServicesIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAiChatRoute: AppSettingsAiChatRoute,
  AppSettingsApprovalsRoute: AppSettingsApprovalsRoute,
  AppSettingsBranchesRoute: AppSettingsBranchesRoute,
  AppSettingsClinicalRoute: AppSettingsClinicalRoute,
  AppSettingsCustomersRoute: AppSettingsCustomersRoute,
  AppSettingsInventoryRoute: AppSettingsInventoryRoute,
  AppSettingsLineRoute: AppSettingsLineRoute,
  AppSettingsMembersRoute: AppSettingsMembersRoute,
  AppSettingsMetaChannelsRoute: AppSettingsMetaChannelsRoute,
  AppSettingsOnlineBookingRoute: AppSettingsOnlineBookingRoute,
  AppSettingsOnlineOrderingRoute: AppSettingsOnlineOrderingRoute,
  AppSettingsPaymentsRoute: AppSettingsPaymentsRoute,
  AppSettingsPositionsRoute: AppSettingsPositionsRoute,
  AppSettingsRemindersRoute: AppSettingsRemindersRoute,
  AppSettingsRentalRoute: AppSettingsRentalRoute,
  AppSettingsResourcesRoute: AppSettingsResourcesRoute,
  AppSettingsRolesRoute: AppSettingsRolesRoute,
  AppSettingsSkillsRoute: AppSettingsSkillsRoute,
  AppSettingsTenantRoute: AppSettingsTenantRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsLineGuideRoute: AppSettingsLineGuideRoute,
  AppSettingsServicesImportRoute: AppSettingsServicesImportRoute,
  AppSettingsServicesIndexRoute: AppSettingsServicesIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppAiChatRoute: typeof AppAiChatRoute
  AppApprovalsRoute: typeof AppApprovalsRoute
  AppBillingRoute: typeof AppBillingRoute
  AppBillsRoute: typeof AppBillsRoute
  AppBranchCompareRoute: typeof AppBranchCompareRoute
  AppCalendarRoute: typeof AppCalendarRoute
  AppCashRoute: typeof AppCashRoute
  AppCloseDayRoute: typeof AppCloseDayRoute
  AppComplaintsRoute: typeof AppComplaintsRoute
  AppFinanceRoute: typeof AppFinanceRoute
  AppFollowupsRoute: typeof AppFollowupsRoute
  AppGoalsRoute: typeof AppGoalsRoute
  AppHealthRoute: typeof AppHealthRoute
  AppInboxRoute: typeof AppInboxRoute
  AppKpiRoute: typeof AppKpiRoute
  AppLeaveRequestsRoute: typeof AppLeaveRequestsRoute
  AppLoyaltyRoute: typeof AppLoyaltyRoute
  AppManualRoute: typeof AppManualRoute
  AppMessagesRoute: typeof AppMessagesRouteWithChildren
  AppOnlineBookingRoute: typeof AppOnlineBookingRoute
  AppOrdersRoute: typeof AppOrdersRoute
  AppPayMethodRoute: typeof AppPayMethodRoute
  AppPayoutsRoute: typeof AppPayoutsRoute
  AppPrivacyRoute: typeof AppPrivacyRoute
  AppRatingsRoute: typeof AppRatingsRoute
  AppReceivingAccountsRoute: typeof AppReceivingAccountsRoute
  AppRentalReportRoute: typeof AppRentalReportRoute
  AppRentalsRoute: typeof AppRentalsRoute
  AppReportsRoute: typeof AppReportsRoute
  AppReportsInboxRoute: typeof AppReportsInboxRoute
  AppRulesRoute: typeof AppRulesRouteWithChildren
  AppSalesReportRoute: typeof AppSalesReportRoute
  AppSalesSummaryRoute: typeof AppSalesSummaryRoute
  AppServiceRecordsRoute: typeof AppServiceRecordsRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppSetupRoute: typeof AppSetupRoute
  AppStaffRoute: typeof AppStaffRoute
  AppTablesRoute: typeof AppTablesRoute
  AppTodayRoute: typeof AppTodayRoute
  AppVacationTestRoute: typeof AppVacationTestRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAccountSecurityRoute: typeof AppAccountSecurityRoute
  AppChecklistsNewRoute: typeof AppChecklistsNewRoute
  AppCustomersCustomerIdRoute: typeof AppCustomersCustomerIdRoute
  AppCustomersImportRoute: typeof AppCustomersImportRoute
  AppHelpTopicRoute: typeof AppHelpTopicRoute
  AppImportsPosRoute: typeof AppImportsPosRoute
  AppInventoryImportRoute: typeof AppInventoryImportRoute
  AppInventoryIngredientsRoute: typeof AppInventoryIngredientsRoute
  AppInventoryProductsRoute: typeof AppInventoryProductsRoute
  AppInventoryReportsRoute: typeof AppInventoryReportsRoute
  AppInventorySellRoute: typeof AppInventorySellRoute
  AppInventoryStockRoute: typeof AppInventoryStockRoute
  AppMeApprovalRoute: typeof AppMeApprovalRoute
  AppMeChecklistsRoute: typeof AppMeChecklistsRoute
  AppMeEarningsRoute: typeof AppMeEarningsRoute
  AppMeLeaveRoute: typeof AppMeLeaveRoute
  AppMeNotificationsRoute: typeof AppMeNotificationsRoute
  AppMeScheduleRoute: typeof AppMeScheduleRoute
  AppMeSopsRoute: typeof AppMeSopsRoute
  AppMeTodayRoute: typeof AppMeTodayRoute
  AppRentalsImportRoute: typeof AppRentalsImportRoute
  AppRentalsImportBookingsRoute: typeof AppRentalsImportBookingsRoute
  AppRentalsPhotosRoute: typeof AppRentalsPhotosRoute
  AppShiftsTemplatesRoute: typeof AppShiftsTemplatesRoute
  AppSopsNewRoute: typeof AppSopsNewRoute
  AppSurveysIdRoute: typeof AppSurveysIdRoute
  AppTeamRiskRoute: typeof AppTeamRiskRoute
  AppChecklistsIndexRoute: typeof AppChecklistsIndexRoute
  AppCheckoutIndexRoute: typeof AppCheckoutIndexRoute
  AppClinicalIndexRoute: typeof AppClinicalIndexRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppHelpIndexRoute: typeof AppHelpIndexRoute
  AppShiftsIndexRoute: typeof AppShiftsIndexRoute
  AppSopsIndexRoute: typeof AppSopsIndexRoute
  AppSurveysIndexRoute: typeof AppSurveysIndexRoute
  AppChecklistsIdEditRoute: typeof AppChecklistsIdEditRoute
  AppChecklistsRunsRunIdRoute: typeof AppChecklistsRunsRunIdRoute
  AppCheckoutBillIdReceiptRoute: typeof AppCheckoutBillIdReceiptRoute
  AppClinicalPatientsCustomerIdRoute: typeof AppClinicalPatientsCustomerIdRoute
  AppInventoryCountIdRoute: typeof AppInventoryCountIdRoute
  AppSopsIdEditRoute: typeof AppSopsIdEditRoute
  AppTeamIdOffboardingRoute: typeof AppTeamIdOffboardingRoute
  AppCheckoutBillIdIndexRoute: typeof AppCheckoutBillIdIndexRoute
  AppInventoryCountIndexRoute: typeof AppInventoryCountIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAiChatRoute: AppAiChatRoute,
  AppApprovalsRoute: AppApprovalsRoute,
  AppBillingRoute: AppBillingRoute,
  AppBillsRoute: AppBillsRoute,
  AppBranchCompareRoute: AppBranchCompareRoute,
  AppCalendarRoute: AppCalendarRoute,
  AppCashRoute: AppCashRoute,
  AppCloseDayRoute: AppCloseDayRoute,
  AppComplaintsRoute: AppComplaintsRoute,
  AppFinanceRoute: AppFinanceRoute,
  AppFollowupsRoute: AppFollowupsRoute,
  AppGoalsRoute: AppGoalsRoute,
  AppHealthRoute: AppHealthRoute,
  AppInboxRoute: AppInboxRoute,
  AppKpiRoute: AppKpiRoute,
  AppLeaveRequestsRoute: AppLeaveRequestsRoute,
  AppLoyaltyRoute: AppLoyaltyRoute,
  AppManualRoute: AppManualRoute,
  AppMessagesRoute: AppMessagesRouteWithChildren,
  AppOnlineBookingRoute: AppOnlineBookingRoute,
  AppOrdersRoute: AppOrdersRoute,
  AppPayMethodRoute: AppPayMethodRoute,
  AppPayoutsRoute: AppPayoutsRoute,
  AppPrivacyRoute: AppPrivacyRoute,
  AppRatingsRoute: AppRatingsRoute,
  AppReceivingAccountsRoute: AppReceivingAccountsRoute,
  AppRentalReportRoute: AppRentalReportRoute,
  AppRentalsRoute: AppRentalsRoute,
  AppReportsRoute: AppReportsRoute,
  AppReportsInboxRoute: AppReportsInboxRoute,
  AppRulesRoute: AppRulesRouteWithChildren,
  AppSalesReportRoute: AppSalesReportRoute,
  AppSalesSummaryRoute: AppSalesSummaryRoute,
  AppServiceRecordsRoute: AppServiceRecordsRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppSetupRoute: AppSetupRoute,
  AppStaffRoute: AppStaffRoute,
  AppTablesRoute: AppTablesRoute,
  AppTodayRoute: AppTodayRoute,
  AppVacationTestRoute: AppVacationTestRoute,
  AppIndexRoute: AppIndexRoute,
  AppAccountSecurityRoute: AppAccountSecurityRoute,
  AppChecklistsNewRoute: AppChecklistsNewRoute,
  AppCustomersCustomerIdRoute: AppCustomersCustomerIdRoute,
  AppCustomersImportRoute: AppCustomersImportRoute,
  AppHelpTopicRoute: AppHelpTopicRoute,
  AppImportsPosRoute: AppImportsPosRoute,
  AppInventoryImportRoute: AppInventoryImportRoute,
  AppInventoryIngredientsRoute: AppInventoryIngredientsRoute,
  AppInventoryProductsRoute: AppInventoryProductsRoute,
  AppInventoryReportsRoute: AppInventoryReportsRoute,
  AppInventorySellRoute: AppInventorySellRoute,
  AppInventoryStockRoute: AppInventoryStockRoute,
  AppMeApprovalRoute: AppMeApprovalRoute,
  AppMeChecklistsRoute: AppMeChecklistsRoute,
  AppMeEarningsRoute: AppMeEarningsRoute,
  AppMeLeaveRoute: AppMeLeaveRoute,
  AppMeNotificationsRoute: AppMeNotificationsRoute,
  AppMeScheduleRoute: AppMeScheduleRoute,
  AppMeSopsRoute: AppMeSopsRoute,
  AppMeTodayRoute: AppMeTodayRoute,
  AppRentalsImportRoute: AppRentalsImportRoute,
  AppRentalsImportBookingsRoute: AppRentalsImportBookingsRoute,
  AppRentalsPhotosRoute: AppRentalsPhotosRoute,
  AppShiftsTemplatesRoute: AppShiftsTemplatesRoute,
  AppSopsNewRoute: AppSopsNewRoute,
  AppSurveysIdRoute: AppSurveysIdRoute,
  AppTeamRiskRoute: AppTeamRiskRoute,
  AppChecklistsIndexRoute: AppChecklistsIndexRoute,
  AppCheckoutIndexRoute: AppCheckoutIndexRoute,
  AppClinicalIndexRoute: AppClinicalIndexRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppHelpIndexRoute: AppHelpIndexRoute,
  AppShiftsIndexRoute: AppShiftsIndexRoute,
  AppSopsIndexRoute: AppSopsIndexRoute,
  AppSurveysIndexRoute: AppSurveysIndexRoute,
  AppChecklistsIdEditRoute: AppChecklistsIdEditRoute,
  AppChecklistsRunsRunIdRoute: AppChecklistsRunsRunIdRoute,
  AppCheckoutBillIdReceiptRoute: AppCheckoutBillIdReceiptRoute,
  AppClinicalPatientsCustomerIdRoute: AppClinicalPatientsCustomerIdRoute,
  AppInventoryCountIdRoute: AppInventoryCountIdRoute,
  AppSopsIdEditRoute: AppSopsIdEditRoute,
  AppTeamIdOffboardingRoute: AppTeamIdOffboardingRoute,
  AppCheckoutBillIdIndexRoute: AppCheckoutBillIdIndexRoute,
  AppInventoryCountIndexRoute: AppInventoryCountIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthInviteTokenRoute: typeof AuthInviteTokenRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthInviteTokenRoute: AuthInviteTokenRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicRouteChildren {
  PublicPayTokenRoute: typeof PublicPayTokenRoute
  PublicRCodeRoute: typeof PublicRCodeRoute
  PublicSTokenRoute: typeof PublicSTokenRoute
  PublicRIndexRoute: typeof PublicRIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicPayTokenRoute: PublicPayTokenRoute,
  PublicRCodeRoute: PublicRCodeRoute,
  PublicSTokenRoute: PublicSTokenRoute,
  PublicRIndexRoute: PublicRIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  ImpersonateRoute: ImpersonateRoute,
  OnboardingRoute: OnboardingRoute,
  SelectTenantRoute: SelectTenantRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  ApproveTokenRoute: ApproveTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
